import styled from 'styled-components'
import Theme from 'theme'

export const StyledSpecificationsComparisonsReport = styled.div`
  .tableStyle {
    display: table;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    box-sizing: border-box;
    table-layout: fixed;
    width: 100%;
    border-spacing: unset;
  }

  .tableRow {
    display: table-row;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    box-sizing: border-box;
  }

  .tableRow:nth-child(odd) > .tableCell {
    background-color: ${Theme.colors.ultraLightGrey};
  }

  .tableRow:nth-child(even) > .tableCell {
    background-color: ${Theme.colors.white};
  }

  .tableCell {
    width: 220px;
    padding: 0;
    vertical-align: top,
    background-color: '#FAFAFA',
  }

  .cellContent {
    padding: 8px 16px;
    text-align: left;
    vertical-align: top;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 45px;
    overflow: hidden;
  }

  .cellContent img {
    margin-left: 10px;
  }

  .sticky {
    position: sticky;
    left: 0;
  }

  img {
    vertical-align: middle;
  }
`
